import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { LocaleCountriesQuery as LocaleCountriesQueryType } from "./__generated__/LocaleCountriesQuery";

const LocaleCountriesQuery = loader("./LocaleCountriesQuery.gql");

type LocaleCountriesQueryProviderType = (props: {
  children: (data: LocaleCountriesQueryType) => ReactNode;
}) => ReactElement;

export const LocaleCountriesQueryProvider: LocaleCountriesQueryProviderType = (props) => {
  const { children } = props;

  const { error, loading, data } = useQuery<LocaleCountriesQueryType>(LocaleCountriesQuery, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
